import { IRequestReviewDocumentNote } from "./RequestReviewDocumentNote";

export interface IRequestReviewDocumentEnvelope {
  requestReviewDocumentDTO: IRequestReviewDocument[];
  requestReviewDocumentCount: number;
}

export interface DocumentQuestions {
  id: string;
  question: string;
  responseType: string;
  answer: boolean;
  answerText: string | null;
  answerId: string;
}

export interface Notes {
  id: string;
  question: string;
  answer: boolean;
  answerId: string;
}

export interface IRequestReviewDocument {
  id: string;
  requestReviewId: string;
  documentTypeId: string;
  documentType: string;
  requestDate: Date;
  createdOn: Date;
  questions: DocumentQuestions[];
  notes: IRequestReviewDocumentNote[];
  noteCount: number;
  docCount: number;
  noteRequired: boolean;
  required: boolean;
}

export class CreateRequestReviewDocument {
  requestReviewId: string = "";
  documentType: string = "";
}
